import script from "./AgencyDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgencyDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./AgencyDashboard.vue?vue&type=style&index=0&id=25610ac7&lang=css"

const __exports__ = script;

export default __exports__